export const sendMissingUnit = (trigger) => {
    trigger('genericEvent', {
        category: 'owner-activity',
        action: 'save-on-location-page',
        label: 'missing-unit-by-vendor'
    });
};

export const sendCheckHasNoUnit = (trigger) => {
    trigger('genericClick', {
        category: 'owner-activity',
        action: 'check-no-unit-box',
        label: 'has-no-unit'
    });
};

export const sendCheckHasUnit = (trigger) => {
    trigger('genericClick', {
        category: 'owner-activity',
        action: 'check-no-unit-box',
        label: 'has-unit'
    });
};

export const sendFlowSummary = (trigger, isManual, errors = []) => {
    trigger('genericEvent', {
        category: 'owner-activity',
        action: 'save-on-location-page',
        label: 'successful-submission',
        page: isManual ? 'manual' : 'typeahead',
        errors
    });
};

export const sendUserMovesPin = (trigger) => {
    trigger('genericEvent', {
        category: 'owner-activity',
        action: 'verify-location-change',
        label: 'mapPin'
    });
};
